export type ServicesDisplayPositionType = 1 | 2 | 3;

interface IServicesDisplayPositionTypeEnum {
    Middle: ServicesDisplayPositionType;
    Left: ServicesDisplayPositionType;
    Right: ServicesDisplayPositionType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 1, text: 'Tik paslaugos' },
    { key: 2, text: 'Paslaugos ir nuotrauka' },
    { key: 3, text: 'Nuotrauka ir paslaugos' }
];

export const servicesDisplayPositionType: IServicesDisplayPositionTypeEnum = {
    Middle: 1,
    Left: 2,
    Right: 3,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
